import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center bg-baseBlue text-white justify-center h-screen text-baseBlue">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-baseGreen">404</h1>
        <h2 className="mt-4 text-3xl font-semibold">
          Oops! The page you're looking for doesn't exist.
        </h2>
        <p className="mt-2 ">
          It seems the page you're trying to reach is not available.
        </p>
        <Link to="/">
          <button className="mt-6 px-6 py-2 bg-baseGreen text-baseBlue rounded-lg hover:bg-darkGreen focus:outline-none focus:ring-4 focus:ring-darkGreen">
            Go Back to Home
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
